import config from "../config";

export const getGcpRequestAppLink = (customerId: string, siteId: string) =>
  `${config.endpoints.gcpRequestApp}/${customerId}/${siteId}`;
